import { ErrorMessage, Field } from "formik";
import React from "react";
import PhoneInput from "react-phone-input-2";
import { handleKeyDown } from "../../../Common/FewCommonMethods";
import AsteriskLabel from "../../../Common/AsteriskLabel";

export default function PhoneInputforSignUp({
  errors,
  formik,
  values,
  touched,
  setFieldValue,
}) {
  const modifyCountyCodeValue = (
    setFieldValue,
    countryCode,
    mobileWithCounty,
  ) => {
    setFieldValue("country_code", `+${countryCode}`);
  };

  return (
    <>
      <div className=" d-flex  signup-mobile-1">
        {/* Country Code Field */}
        <div className="country-code-field mr-3">
          <label htmlFor="country_code">Country Code <AsteriskLabel /></label>
          <PhoneInput
            value={values.country_code}
            onChange={(value, country) => {
              modifyCountyCodeValue(setFieldValue, country.dialCode, value);
            }}
            inputProps={{
              name: "mobile_number",
              id: "mobile_number",
              className: "form-control",
              readOnly: true,
            }}
            specialLabel=""
            buttonStyle={{ borderRadius: "0", border: "1px solid #ced4da" }}
            containerStyle={{ marginBottom: "10px" }}
          />
          <ErrorMessage name="country_code" component="div" className="error" />
        </div>

        {/* Mobile Number Field */}
        <div className="mobile-number-field">
          <label htmlFor="mobile_number">Mobile Number <AsteriskLabel /></label>
          <Field
            type="text"
            name="mobile_number"
            className={`form-control ${errors.mobile_number && touched.mobile_number ? "is-invalid" : ""}`}
            placeholder="Enter mobile number"
            onKeyDown={handleKeyDown}
          />
          <ErrorMessage
            name="mobile_number"
            component="div"
            className="error"
          />
        </div>
      </div>
    </>
  );
}
